<template>
  <SkeletonRoot
    v-if="loadMoreSleleton"
    v-for="(_, index) in nums"
    :delay="Math.floor(index / (deviceType === 'MOBILE' ? 2 : 6))"
  >
    <Skeleton
      aspect-ratio="1"
    />
    <div :style="{ marginTop: '8px', paddingLeft: '4px' }">
      <Skeleton width="80px" />
      <Skeleton height="16px" />
      <Skeleton width="80px" />
      <Skeleton
        :style="{ marginTop: '12px' }"
        height="16px"
      />
      <Skeleton width="80px" />
    </div>
  </SkeletonRoot>
</template>

<script setup>
import { SkeletonRoot, Skeleton } from '@/components/Skeleton'
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useDevice } from '@/hooks/useDevice'

const store = useStore()
const nums = ref(60)

const { deviceType } = useDevice()

const loadMoreSleleton = computed(() => store.state.loadMoreSleleton)

watch(
  () => store.state.productList.length,
  (newData) => {
    nums.value = newData % 6 === 0 ? 6 : (6 - (newData % 6)) + 6
  }
)

</script>

<style lang="less">
@import './index.less';
</style>
